import React from 'react';
import { Activity } from 'lucide-react';
import AirBoardPage from './AirBoardPage';
import { SUBESTADOS_EN_CURSO } from '../utils/airBoardConstants';

/**
 * Tablero "Operaciones en curso" del aéreo — solicitudes en estado `Enviada`.
 *
 * Ciclo de vida: confirmación → documentación → tránsito → aduana. No se
 * eliminan: una operación que no sigue se cancela.
 */
const ACCIONES_ESTADO = [
  {
    key: 'finalizar',
    icon: 'CheckCircle2',
    tooltip: 'Finalizar y pasar a Finalizadas',
    className: 'hover:bg-emerald-500 hover:text-white',
    confirmar: (codigo) => `¿Finalizar la operación ${codigo}? Pasará a Finalizadas.`,
    cambio: { estado: 'Aprobada' },
    exito: 'Operación finalizada',
    error: 'No se pudo finalizar',
  },
  {
    key: 'cancelar',
    icon: 'XCircle',
    tooltip: 'Cancelar y pasar a Rechazadas',
    className: 'hover:bg-rose-500 hover:text-white',
    confirmar: (codigo) => `¿Cancelar la operación ${codigo}? Pasará a Rechazadas.`,
    cambio: { estado: 'Rechazada' },
    exito: 'Operación cancelada',
    error: 'No se pudo cancelar',
  },
];

export default function InProgressBoardPage() {
  return (
    <AirBoardPage
      estado="Enviada"
      titulo="Operaciones en curso"
      subtitulo="Solicitudes en estado Enviada · confirmación → tránsito → aduana"
      icon={Activity}
      iconClass="bg-blue-100 text-blue-700"
      subEstadoOptions={SUBESTADOS_EN_CURSO}
      exportFileName="aereo_en_curso"
      accionesEstado={ACCIONES_ESTADO}
    />
  );
}
